export default __webpack_public_path__ + "static/media/moisture-icon.12c3a985.svg";